const validateEmail = (email) => {
  // eslint-disable-next-line no-useless-escape
  const emailFormatReg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
  return emailFormatReg.test(email) ? true : false;
};

const readCookie = (key) => {
  const value = document.cookie.match(new RegExp(`${key}=([^;]+)`)) || [];
  return decodeURIComponent(value[1] || '');
};
const writeCookie = (key, value, expireDays = 0) => {
  const now = new Date();
  now.setTime(now.getTime() + (expireDays * 86400000));
  const expires = expireDays == 0 ? '' : '; expires=' + now.toUTCString();
  const path = ";path=/";
  document.cookie = `${key}=${encodeURIComponent(value)}${expires}${path}`;
};

// Cookie writer with explicit attributes; writeCookie above is left unchanged for existing callers.
const writeCookieWithOptions = (key, value, { domain, maxAgeSeconds, sameSite } = {}) => {
  let cookie = `${key}=${encodeURIComponent(value)}; path=/`;
  if(typeof maxAgeSeconds === 'number') {
    cookie += `; max-age=${maxAgeSeconds}`;
  }
  if(domain) {
    cookie += `; domain=${domain}`;
  }
  if(sameSite) {
    cookie += `; SameSite=${sameSite}`;
  }
  document.cookie = cookie;
};

const deleteCookie = (key) => {
  writeCookie(key, '', true)
};

const deleteAllCookies = () => {
  document.cookie.split(";").forEach(function(c) { document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); });
};

//return true when user has valid session
//return false when user is not logged in
const isUserLoggedIn = () => {
  if (typeof window.document === 'undefined' || !window.hasOwnProperty('Object')) {
    return false;
  }

  if (localStorage.getItem('loggingOut') === 'true') {
    return false;
  }

  //note
  //when integrating with apple and google, we may need to check more here
  const sessionCookieExists = cookieExists('accessToken');
  return sessionCookieExists || hasLocalAccessToken();
};

const cookieExists = (key) => {
  const cookieValue = readCookie(key);
  if(cookieValue != null && cookieValue != undefined && cookieValue != 'undefined' && cookieValue != '') {
    return true;
  }

  return false;
};

const hasLocalAccessToken = () => {
  return typeof getLocalAccessToken() === 'string' && getLocalAccessToken() != '';
};

const getLocalAccessToken = () => {
  try {
    let accessToken = '';
    if (typeof localStorage !== 'undefined' && typeof localStorage.tinybeansstore !== 'undefined') {
      accessToken = JSON.parse(localStorage.tinybeansstore).authenticated.accessToken;  
    } else {
      accessToken = readCookie('accessToken');  
    }

    if(accessToken !== undefined) {
      return accessToken;
    }

    return undefined;
  }

  catch (e) {
    return undefined;
  }
};

//Not sure why we need to store referralCode in localStorage
const getReferralCode = () => {
  const codeOne = readCookie('referralCode');

  if (typeof codeOne === 'string' && codeOne.length > 0) {
    return codeOne;
  }

  const codeTwo = localStorage.getItem('referralCode');

  if (typeof codeTwo === 'string' && codeTwo.length > 0) {
    return codeTwo;
  }

  return '';
};

const getInviteToken = () => {
  return readCookie('inviteToken') ? readCookie('inviteToken') : '';
};

// PAE-2465 item 15: Signup.vue writes `abTest`, this used to read `ab-test`, so the email signup
// form always sent an empty value. `abTest` is the name every writer and reader now agrees on;
// `ab-test` is read only as a fallback for a cookie set before this fix.
const AB_TEST_COOKIE = 'abTest';
const getabTest = () => {
  const value = readCookie(AB_TEST_COOKIE) || readCookie('ab-test');
  return value ? value : '';
};

const getCampaignCode = () => {
  const campaignCode = readCookie('campaign') ? readCookie('campaign') : readCookie('_src');
  return campaignCode ? campaignCode : '';
};

export {
  validateEmail,
  readCookie,
  writeCookie,
  writeCookieWithOptions,
  deleteCookie,
  deleteAllCookies,
  isUserLoggedIn,
  getLocalAccessToken,
  getReferralCode,
  getInviteToken,
  getabTest,
  getCampaignCode
};

